import React from 'react'
import cn from 'classnames'
import styles from './filter-tabs.module.scss'

export default function Tabs({ activeTab, onTabChange, tabs, ariaLabel = 'Content tabs' }) {
    if (!Array.isArray(tabs) || tabs.length === 0) return null

    return (
        <div
            className={cn(
                styles.filterTabs,
                tabs.length > 3 && styles.crowded,
                tabs.length === 2 && styles.pair,
            )}
            role="tablist"
            aria-label={ariaLabel}
        >
            {tabs.map(tab => {
                const active = activeTab === tab.key
                const Icon = tab.icon

                return (
                    <button
                        key={tab.key}
                        type="button"
                        role="tab"
                        className={cn(styles.tab, active && styles.active)}
                        data-testid={tab.testId}
                        aria-selected={active}
                        aria-pressed={active}
                        onClick={() => {
                            tab.onSelect?.()
                            onTabChange(tab.key)
                        }}
                    >
                        {tab.renderIcon
                            ? tab.renderIcon(active)
                            : Icon && <Icon size={20} className={styles.icon} />}
                        <span>{tab.label}</span>
                    </button>
                )
            })}
        </div>
    )
}
